export default __webpack_public_path__ + "static/media/Shemite Mercenary Turban.d29ef14d.jpg";